import React from "react";
import { Link } from "react-router-dom";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";
import ImgMediaCard from "../../../examples/Cards/StatisticsCards/BlogCards";
import cateringIcon from "../../../assets/images/icons/catering-icons/cr-logo-black.svg";
import { SIDE_BANNER_CARD_INFO, SIDE_BANNER_COMPANY_LOGO } from "./constantSideBanner";

export default function SideBanner() {
  return (
    <MDBox
      width={{ xs: "100%", xl: "60%" }}
      p={1}
      pt={{ xs: 4, md: 4 }}
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "space-between",
        background: `
        linear-gradient(135deg, rgba(26, 233, 98, 0.08) 0%, rgba(26, 233, 98, 0.02) 100%)
      `,
        position: "relative",
        height: "100vh",
        overflowY: "auto",
        "&::-webkit-scrollbar": {
          width: "6px",
        },
        "&::-webkit-scrollbar-track": {
          background: "transparent",
        },
        "&::-webkit-scrollbar-thumb": {
          background: "rgba(26, 233, 98, 0.2)",
          borderRadius: "3px",
        },
        "&::before": {
          content: '""',
          position: "absolute",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          background: `
          radial-gradient(circle at 10% 0%, rgba(26, 233, 98, 0.15) 0%, transparent 50%),
          radial-gradient(circle at 90% 90%, rgba(26, 233, 98, 0.1) 0%, transparent 40%),
          radial-gradient(circle at 50% 50%, rgba(255, 255, 255, 0.9) 0%, transparent 70%)
        `,
          pointerEvents: "none",
        },
      }}
    >
      <MDBox
        sx={{
          position: "relative",
          zIndex: 1,
          width: "100%",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          gap: 4,
        }}
      >
        <MDBox
          component="img"
          src={cateringIcon}
          alt="Catering Rewards — Order More, Earn More"
          sx={{
            display: "block",
            width: { xs: "220px", md: "220px" },
            maxWidth: "100%",
            height: "auto",
            filter: "drop-shadow(0 8px 16px rgba(0, 0, 0, 0.1))",
          }}
        />

        <MDBox textAlign="center" mb={2}>
          <MDTypography
            variant="h1"
            sx={{
              fontSize: { xs: "2.2rem", md: "2.8rem" },
              fontWeight: 800,
              color: "#1A202C",
              mb: 2,
              position: "relative",
              "&::after": {
                content: '""',
                position: "absolute",
                bottom: "-12px",
                left: "50%",
                transform: "translateX(-50%)",
                width: "60px",
                height: "4px",
                background:
                  "linear-gradient(90deg, rgba(26, 233, 98, 0.8) 0%, rgba(26, 233, 98, 0.2) 100%)",
                borderRadius: "2px",
              },
            }}
          >
            Cater More. Earn More.
          </MDTypography>

          <MDTypography
            variant="h5"
            sx={{
              fontSize: { xs: "1rem", md: "1.1rem" },
              fontWeight: 500,
              color: "#4A5568",
              maxWidth: "500px",
              margin: "0 auto",
              mt: 3,
              lineHeight: 1.6,
            }}
          >
            Earn cashback rewards everywhere. Track & redeem them here as Amazon.com gift cards.
          </MDTypography>
        </MDBox>

        <MDBox
          sx={{
            display: "flex",
            flexDirection: "column",
            gap: 3,
            width: "100%",
            maxWidth: "800px",
            px: 2,
          }}
        >
          {SIDE_BANNER_CARD_INFO.map((data, index) => (
            <ImgMediaCard key={index} {...data} />
          ))}
        </MDBox>

        <MDBox
          sx={{
            mt: 6,
            textAlign: "center",
            width: "100%",
          }}
        >
          <MDTypography
            variant="h6"
            sx={{
              fontSize: "1.1rem",
              fontWeight: 600,
              color: "#2D3748",
              mb: 3,
            }}
          >
            Earn cashback rewards with top restaurants
          </MDTypography>

          <MDBox
            sx={{
              display: "flex",
              justifyContent: "center",
              gap: 3,
              flexWrap: "wrap",
              mb: 4,
            }}
          >
            {SIDE_BANNER_COMPANY_LOGO.map((data, index) => (
              <MDTypography
                key={index}
                component={Link}
                to={data.link}
                sx={{
                  color: "#4A5568",
                  fontSize: "1rem",
                  fontWeight: 500,
                  padding: "8px 16px",
                  borderRadius: "12px",
                  background: "rgba(255, 255, 255, 0.6)",
                  backdropFilter: "blur(8px)",
                  transition: "all 0.2s ease",
                  textDecoration: "none",
                  "&:hover": {
                    background: "rgba(255, 255, 255, 0.9)",
                    transform: "translateY(-2px)",
                  },
                }}
              >
                {data.text}
              </MDTypography>
            ))}
          </MDBox>
        </MDBox>

        <MDBox
          sx={{
            display: "flex",
            width: "100%",
            justifyContent: "space-between",
            mt: "auto",
            pt: 4,
          }}
        >
          <MDButton
            variant="text"
            color="info"
            size="small"
            target="_blank"
            href="https://cateringrewards.com/privacy_policy/"
            sx={{
              fontSize: "0.875rem",
              color: "#4A5568",
              transition: "all 0.2s ease",
              "&:hover": {
                color: "#1A202C",
                background: "rgba(26, 233, 98, 0.1)",
              },
            }}
          >
            PRIVACY POLICY
          </MDButton>
          <MDButton
            variant="text"
            color="info"
            size="small"
            target="_blank"
            href="https://cateringrewards.com/terms_of_use/"
            sx={{
              fontSize: "0.875rem",
              color: "#4A5568",
              transition: "all 0.2s ease",
              "&:hover": {
                color: "#1A202C",
                background: "rgba(26, 233, 98, 0.1)",
              },
            }}
          >
            TERMS OF USE
          </MDButton>
        </MDBox>
      </MDBox>
    </MDBox>
  );
}
